import React from "react";

import { Container } from "./IconWrapper.styled";
import { IconWrapperProps } from "./iconWrapper.type";

const IconWrapper = ({ children, handleClick }: IconWrapperProps) => {
  return <Container onClick={handleClick}>{children}</Container>;
};

export default IconWrapper;
